import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Paper, Typography } from "@mui/material";

import routes from "../../constants/routes";
import SecondaryButton from "../../widgets/Buttons/SecondaryButton";
import styles from "./StudentDetails.module.scss";

const StudentDetailsLayout = ({
  vertical,
  studentData,
  studentInfoSlot,
  callActionSlot,
  operationGroups,
}) => {
  const navigate = useNavigate();

  if (!studentData) {
    return (
      <div className={styles.wrapper}>
        <p className={styles.noData}>No student data found.</p>
      </div>
    );
  }

  return (
    <div className={styles.wrapper}>
      <div className={styles.headerBox}>
        <h2 className={styles.title}>Student Details</h2>
        <div className={styles.badge}>
          {vertical || "Vertical Not Selected"}
        </div>
        <div className={styles.headerSpacer} />
        {callActionSlot && (
          <div className={styles.headerActionWrapper}>{callActionSlot}</div>
        )}
        <SecondaryButton
          onClick={() => navigate(routes.home.root)}
          className={styles.headerButton}
        >
          Back
        </SecondaryButton>
      </div>

      <div className={styles.studentDetailsContent}>
        {studentInfoSlot}
        {operationGroups?.length ? (
          <Paper elevation={0} className={styles.actionsPanel}>
            <Typography component="h3" className={styles.operationsTitle}>
              Student Operations
            </Typography>
            <Box className={styles.operationButtons}>
              {operationGroups.map((group) => (
                <React.Fragment key={group.title}>
                  {group.content}
                </React.Fragment>
              ))}
            </Box>
          </Paper>
        ) : null}
      </div>
    </div>
  );
};

export default StudentDetailsLayout;
